import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { PriceRequestItemsClipboardService } from '../../inquiries/custom-made-price-requests/services/price-request-items-clipboard.service';
import { OrderItemsClipboardService } from '../../orders/order-items-clipboard/order-items-clipboard.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  private authService = inject(AuthService);
  private orderItemsClipboardService = inject(OrderItemsClipboardService);
  private priceRequestItemsClipboardService = inject(PriceRequestItemsClipboardService);

  ngOnInit() {
    this.orderItemsClipboardService.clearClipboard();
    this.priceRequestItemsClipboardService.clearClipboard();
    this.authService.logout();
  }
}
